import React, { useState, useContext, useEffect } from 'react';

import PropTypes from 'prop-types';

import './VettingWorkDetails.css';

import VettingDropDown from '../../Common/VettingDropDown/VettingDropDown';
import VettingInput from '../../Common/VettingInput/VettingInput';
import KeyValueDataComponent from '../../CreditVetting/KeyValueDataComponent/KeyValueDataComponent';

import * as VettingHelpers from '../creditVettingUtils';

import {
  SalesContext
} from "./../../../Context/SalesContext";
import {
  FormFieldLabel
} from '../../../StyledComponents';
import {
  checkInputValidity,
  getKeyValueData,
  createArray,
  registerEnterEvent
} from '../../../Utility/utility';

const validateComponent = (component) => {
  component.isValid = checkInputValidity(
    component.value,
    component.validations
  );
  component.isTouched = true;

  return component;
}

const isValidForm = (form) => !Object.values(form).some(field => !field.isValid);

const VettingWorkDetails = (props) => {

  const context = useContext(SalesContext);
  const workDetails = context.vettingCreditDetails.workDetails;
  const dropDownValues = context.dropDownValues;

  const occupationTypesArray = dropDownValues.FASTTRACK_OCCUPATION_TYPE.map(item => item.name);
  const employmentIndustryArray = dropDownValues.EMPLOYMENT_INDUSTORY.map(item => item.name);
  const employerCategoryArray = dropDownValues.EMPLOYMENT_CATEGORY.map(item => item.name);
  const salaryDayArray = dropDownValues.SALARY_DAY.map(item => item.name);
  const salaryFrequencyArray = dropDownValues.SALARY_FREQUENCY.map(item => item.name);

  const options = { occupationTypesArray, employmentIndustryArray, employerCategoryArray, salaryDayArray, salaryFrequencyArray }
  const [formData, setFormData] = useState({
    formComponents: VettingHelpers.createWorkDetailsFormConfig(workDetails, options),
    isFormValid: false,
  });

  const [tempFormData, setTempFormData] = useState(formData.formComponents);

  // Create array
  const formCompArray = createArray(formData.formComponents);
  registerEnterEvent();

  const createUpdatedForm = (fieldKey, value, currForm = formData.formComponents) => {

    const changedComponent = { ...currForm[fieldKey] };

    if (fieldKey === 'employerPhoneNumber') {
      changedComponent.value = value.trim();
    }
    else {
      changedComponent.value = value;
    }

    const validatedForm = {
      ...currForm,
      [fieldKey]: validateComponent(changedComponent)
    };

    let updatedForm = null;
    const loweredValue = value.toLowerCase();

    if (
      fieldKey === "occupationType"
      && ['unemployed', 'student', 'casual / contractor'].includes(loweredValue)
    ) {
      updatedForm = {
        occupationType: validatedForm[fieldKey]
      };
      props.hideNextSection(true);
    } else {
      if (fieldKey != "occupationType" && validatedForm[fieldKey]) {
        updatedForm = validatedForm;
        setTempFormData({ ...updatedForm });
      } else {
        updatedForm = {
          ...tempFormData,
          [fieldKey]: validatedForm[fieldKey]
        };

        setTempFormData({ ...updatedForm });
      }

      props.hideNextSection(false);
    }

    return updatedForm;
  };

  useEffect(() => {
    if (props.isEditModeOn) {
      let updatedForm = formData.formComponents;

      for (let key in workDetails) {
        if (
          workDetails[key] === ""
          || typeof formData.formComponents !== 'object'
          || Object.keys(formData.formComponents[key]).length === 0
        ) {
          continue;
        }

        updatedForm = createUpdatedForm(key, workDetails[key].value, updatedForm);
      }

      const isFormValid = isValidForm(updatedForm);

      setFormData({
        formComponents: updatedForm,
        isFormValid: isFormValid,
      });

      props.toggleNext(isFormValid);
    }
  }, [props.isEditModeOn, workDetails]);

  const formComponentChangeHandler = (event, inputIdentifier) => {
    const fieldComponent = formData.formComponents[inputIdentifier];

    if (fieldComponent.validations.type === "number") {
      let lastChar = event.slice(-1);
      if (isNaN(lastChar)) {
        return false;
      }
    }

    const updatedForm = createUpdatedForm(inputIdentifier, event);
    const isFormValid = isValidForm(updatedForm);

    setFormData({
      formComponents: updatedForm,
      isFormValid: isFormValid,
    });

    props.toggleNext(isFormValid);
  }

  const saveDetails = () => {
    const keyValueData = getKeyValueData(formData.formComponents);
    if (keyValueData['timeSpentAtCurrentEmployeryy']){
      let tempObj = {
        label: "Current employement",
        value: `${keyValueData['timeSpentAtCurrentEmployeryy'].value} years ${keyValueData['timeSpentAtCurrentEmployermm'].value} months`
      }
      keyValueData['currentEmployment'] = tempObj;
      tempObj = {
        label: "Previous employment",
        value: `${keyValueData['timeSpentAtPreviousEmployeryy'].value} years ${keyValueData['timeSpentAtPreviousEmployermm'].value} months`
      }
      keyValueData['previousEmployment'] = tempObj;
    }
    
    context.setVettingDetails('workDetails', keyValueData);
    props.onNextClick(keyValueData);
  }

  return(
    <React.Fragment>
      <div className="vetting-main-section-wrapper">
        {
          workDetails && !props.isEditModeOn ?
            <KeyValueDataComponent data={workDetails} />
            :
            <React.Fragment>
              <div className="vetting-pd-wrapper">
                {
                  formCompArray.map(item => {
                    return (
                      <div className={`input-field-wrapper-${item.config.width}`} key={item.key}>
                        <FormFieldLabel
                          hide={item?.config?.hideLabel ? 1 : 0}
                          automationidattr={`workDetails${item.config.name}`}
                        >
                          {item.config.name}
                        </FormFieldLabel>
                        {
                          item.config.type === "input" ?
                            <VettingInput
                              {...item.config}
                              updateValue={formComponentChangeHandler}
                              inputIdentifier={item.key}
                              automationidattr={`workDetails`}
                            />
                            :
                            null
                        }
                        {
                          item.config.type === "dropDown" ?
                            <VettingDropDown
                              selectedValue={item.config.value}
                              placeholder={item.config.config.placeholder}
                              options={item.config.options}
                              updateSelectedOption={formComponentChangeHandler}
                              inputIdentifier={item.key}
                              automationidattr={`workDetails`}
                            />
                            :
                            null
                        }
                      </div>
                    )
                  })
                }
              </div>
              {
                props.showBody ?
                  <div className="vetting-next-wrapper">
                    <button
                      className={`vetting-section-next-button ${props.enableNext ? 'next-enabled' : ''}`}
                      onClick={() => saveDetails()}
                      disabled={props.enableNext  ? '' : 'disabled'}
                      automationid={`SalesLead_button_workDetailsNextBtn_1"`}
                    >
                      Next
                    </button>
                  </div>
                  :
                  null
              }
            </React.Fragment>
        }
      </div>

    </React.Fragment>
  )
}

VettingWorkDetails.propTypes = {
  enableNext: PropTypes.bool,
  isEditModeOn: PropTypes.bool,
  onNextClick: PropTypes.func,
  showBody: PropTypes.bool,
  toggleNext: PropTypes.func,
  hideNextSection: PropTypes.func,
}

export default VettingWorkDetails;